module.exports = __webpack_public_path__ + "img/online-universities.13af7500.png";